import {
  FETCH_USER_LIST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_FAILURE,
  RELOAD_USER_LIST,
  RESET_USER_ITEMS,
} from '../../action/Users';

const initialState = {
  isLoading: NaN,
  error: '',
  items: [],
};

const UserListReducer = (curState = initialState, action = { type: '', payload: '' }) => {
  let newState;
  switch (action.type) {
    case FETCH_USER_LIST:
      newState = {
        ...curState,
        error: null,
        isLoading: true,
        ...action.payload,
      };
      break;
    case FETCH_USER_LIST_SUCCESS: {
      const {
        resultArr,
      } = action.payload;
      newState = {
        ...curState,
        isLoading: false,
        items: resultArr,
      };
      break;
    }
    case FETCH_USER_LIST_FAILURE:
      newState = {
        ...curState, isLoading: false, error: action.payload,
      };
      break;
    case RESET_USER_ITEMS: {
      newState = { ...initialState };
      break;
    }
    case RELOAD_USER_LIST: {
      newState = { ...initialState };
      break;
    }
    default:
      newState = curState;
  }

  return newState;
};

export default UserListReducer;
